import React from "react";
import Modal from "@material-ui/core/Modal";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import "../styles/modalStyles.css";

const CustomTextModal = (props) => {
  const {
    title,
    isOpen,
    onClose,
    changeField,
    onSubmit,
    initial,
    extraContent,
  } = props;

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      style={{}}
      className={`add-modal ${isOpen ? "visible" : "hidden"}`}
    >
      <div className="add-modal-content">
        <h3>{title}</h3>
        <div className="add-name">
          <TextField
            style={{ width: 400, marginRight: "1em" }}
            label="Name"
            variant="filled"
            fullWidth
            onChange={changeField}
            defaultValue={initial}
            onKeyDown={(e) => {
              if (e.key === "Enter") onSubmit();
            }}
          />
          <Button
            variant="contained"
            style={{ marginRight: "0.5em" }}
            color="primary"
            onClick={onSubmit}
          >
            Submit
          </Button>
          <Button variant="contained" color="secondary" onClick={onClose}>
            Cancel
          </Button>
        </div>
        {extraContent && <div className="extra-content">{extraContent}</div>}
      </div>
    </Modal>
  );
};

export default CustomTextModal;
